<template>
  <div class="status-history">
    <ul class="status-history-list">
      <li v-for="(record, index) in filteredRecords" :key="index" class="status-history-list-item">
        <status-history-list-item :record="record" :resource-domain="resourceDomain" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import StatusHistoryListItem from "@plugins/status-history/components/StatusHistoryListItem.vue";
import { computed } from "vue";

// Props
const props = defineProps({
  resourceDomain: { type: String, required: true },
  records: { type: Array, required: true },
  viewingStatus: { type: String, default: "" },
});

// Computed
const filteredRecords = computed(() => {
  return props.records;
});
</script>
